<template>
  <div>
    <span class="text--l text--bold">{{node.label}}</span>
    <div class="spacer--l"/>
    <div>
      <self-service-vetting-runner-node-requirement
        v-if="node.nodeType === 'Requirement'"
        :options="options"
        @capture="capture($event)"
        @setProjectProperty="setProjectProperty"
      />
      <div v-else-if="node.nodeType === 'Assessment'" class="options">
        <div v-for="option in options" :key="option.id" class="option">
          <a-btn outlined @click="capture(option.id)">{{option.label}}</a-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ABtn from "@/components/SelfService/a-btn.vue";
  import SelfServiceVettingRunnerNodeRequirement
    from "@/components/SelfService/SelfServiceVettingRunnerNodeRequirement.vue";

  export default {
    components: {SelfServiceVettingRunnerNodeRequirement, ABtn},
    props: ['node'],
    methods: {
      capture(value) {
        this.$emit('capture', this.node.id, value)
      },
      setProjectProperty(event) {
        this.$emit('setProjectProperty', event)
      }
    },
    computed: {
      options() {
        switch (this.node.nodeType) {
          case 'Requirement': {
            return this.node.requirements || [];
          }
          case 'Assessment': {
            return this.node.options || [];
          }
          default: {
            return []
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .options {
    display: flex;

    .option {
      padding-right: 8px;
    }
  }
</style>
